import script from "./HeaderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&setup=true&lang=js"

import "./HeaderComponent.vue?vue&type=style&index=0&id=53a3f24b&scoped=true&lang=css"

import exportComponent from "/home/miras_zxc/vc-remote/_work/verification-center-front/verification-center-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53a3f24b"]])

export default __exports__